import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单字段
      form: {
        corpName: null, // 企业名称
        personName: null, // 项目负责人姓名
        idCard: null, // 项目负责人/总监身份证号
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "企业名称：",
          value: "corpName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "项目负责人姓名：",
          value: "personName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "项目负责人身份证号：",
          value: "idCard",
          placeholder: "请输入",
          clearable: true
        },
      ],
      // 表头按钮组
      btnList: [
      ],
      // 列表数据
      tableData: [],
      // 列表基础数据
      tableColumns: [
        {
          label: "姓名",
          prop: "personName",
        },
        {
          label: "身份证号",
          prop: "idCard",
        },
        {
          label: "所属企业",
          prop: "corpName",
        },
        {
          label: "是否有在建工程",
          prop: "isWork",
        },
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 总条数
      total: 0,
      // 温馨提示
      tipList: [
        {
          type: "text",
          text: "（1）如您知道“项目负责人”的“身份证号”，请输入完整的“身份证号”进行查询。",
        },
        {
          type: "text",
          text: "（2）如您不知道“项目负责人”的“身份证号”，请输入完整的“企业名称”和“项目负责人姓名”进行查询。\n",
        },
     ],
  }
},
components: {
},
// 模板编译完成
mounted() {
 // 执行获取列表数据方法
 this.fun_GetList();
},
// 自定义方法
methods: {
 /**
  * 获取列表一览数据
  * @author shuhua
  */
    fun_GetList() {
      // 打开遮罩
      this.loading = true;
      // 发起请求
      fun_PostAction("/checkPmWork/list", {
        ...this.form,
        ...this.reqPageData
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.tableData = data.records;
          // 总条数
          this.total = data.total;
          // 关闭遮罩层
          this.loading = false;
        } else {
          // 关闭遮罩层
          this.loading = false;
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      })
    },
    /**
     * 数据字典查询
     * @author 滕威
     */
    fun_Search() {
      // 身份证为空
      if(!this.form.idCard){
        // 如果企业名称和项目负责人名称都为空
        if(!this.form.corpName || !this.form.personName){
          // 提示请求失败的信息
          this.$message.error("企业名称与项目负责人名称需同时填写！");
          return;
        }
      }
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
  }
}